<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			:minWidth="600"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-list-box-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Prefijo para {{ prefixType }}</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-4">
								<v-col cols="3" class="py-0">
                  <v-text-field
                    v-model="newBudgetPrefix.prefix"
                    label="Prefijo"
                    placeholder="Ingrese el prefijo"
                    outlined
                    required
                    dense
										maxlength="4"
										:rules="[
											v => (v && v.length <= 4) || '4 caracteres',
											requiredRule
										]"
                  ></v-text-field>
                </v-col>
								<v-col cols="9" class="py-0">
                  <v-text-field
                    v-model="newBudgetPrefix.name"
                    label="Nombre"
                    placeholder="Ingrese el nombre"
                    outlined
                    required
                    dense
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
								<v-col cols="12" class="py-0">
									<v-checkbox v-model="newBudgetPrefix.create_title" color="black" :label="'Crear Título para ' + prefixType" hide-details dense></v-checkbox>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {createBudgetPrefix, updateBudgetPrefix} from '@/helpers/api/budgets'

export default {
  name: 'BudgetPrefixesModal',
  components: { },
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
    newBudgetPrefix: {
			budget_prefix_id: null,
			name: null,
			type: 'budget',
			create_title: true
    },
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		prefixType(){
			if(this.newBudgetPrefix.type == 'report'){
				return 'Informe'
			}
			if(this.newBudgetPrefix.type == 'contract'){
				return 'Contrato'
			}
			return 'Presupuesto'
		}
  },
  mounted(){
		if(this.$store.state.budget.newBudgetPrefixModalEditing){
			this.newBudgetPrefix = {...this.newBudgetPrefix, ...this.$store.state.budget.newBudgetPrefixModalEditing}
		}
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
    closeModal(){
      this.$store.commit('budget/setNewBudgetPrefixModal', false)
			this.$store.commit('budget/setNewBudgetPrefixModalEditing', null)
      this.newBudgetPrefix = {
				budget_prefix_id: null,
				prefix: null,
				name: null
			}
      this.validform = true
      this.loadingData = false
    },
    async sendForm(){
      if(this.$refs.form.validate()){
				this.loadingData = true
        const company = this.newBudgetPrefix.budget_prefix_id ? await updateBudgetPrefix(this.newBudgetPrefix):await createBudgetPrefix(this.newBudgetPrefix)
        if(company.code === 200){
          const messageData = {
            message: this.newBudgetPrefix.budget_prefix_id ? 'El prefijo ha sido actualizado':'Se ha creado correctamente el prefijo',
            title: this.newBudgetPrefix.budget_prefix_id ? 'Prefijo Actualizado':'Prefijo creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.checkUpdateTitles(this.newBudgetPrefix)
					this.$store.dispatch('budget/getBudgetPrefixes')
					eventBus.$emit('reloadInformation', {})
          this.setMessage(messageData)
          this.closeModal()
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
				this.loadingData = false
      }
    },
		checkUpdateTitles(prefix){
			if(prefix.create_title){
				if(prefix.type == 'report'){
					this.$store.dispatch('reports/getReportTitles')
				}
				else if(prefix.type == 'budget'){
					this.$store.dispatch('budget/getBudgetTitles')
				}
				else if(prefix.type == 'contract'){
					this.$store.dispatch('contracts/getContractTitles', {start: 0, limit: 100})
				}
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>